import { defineComponent as f, ref as v, computed as _, openBlock as b, createElementBlock as h, unref as e, normalizeClass as o, createElementVNode as p, toDisplayString as u, createVNode as C } from "vue";
import { ElInput as E } from "./index545.js";
import { usePagination as z } from "./index746.js";
import { paginationJumperProps as P } from "./index748.js";
import { useLocale as V } from "./index597.js";
import { useNamespace as x } from "./index559.js";
const I = ["disabled"];
var M = /* @__PURE__ */ f({
  name: "ElPaginationJumper",
  __name: "jumper",
  props: P,
  setup(N) {
    const { t } = V(), n = x("pagination"), { pageCount: m, disabled: l, currentPage: s, changeEvent: r } = z(), i = v(), c = _(() => {
      var a;
      return (a = i.value) != null ? a : s?.value;
    });
    function d(a) {
      i.value = a ? +a : "";
    }
    function g(a) {
      a = Math.trunc(+a), r?.(a), i.value = void 0;
    }
    return (a, j) => (b(), h("span", {
      class: o(e(n).e("jump")),
      disabled: e(l)
    }, [
      p(
        "span",
        {
          class: o([e(n).e("goto")])
        },
        u(e(t)("el.pagination.goto")),
        3
        /* TEXT, CLASS */
      ),
      C(e(E), {
        size: a.size,
        class: o([e(n).e("editor"), e(n).is("in-pagination")]),
        min: 1,
        max: e(m),
        disabled: e(l),
        "model-value": c.value,
        "validate-event": !1,
        "aria-label": e(t)("el.pagination.page"),
        type: "number",
        "onUpdate:modelValue": d,
        onChange: g
      }, null, 8, ["size", "class", "max", "disabled", "model-value", "aria-label"]),
      p(
        "span",
        {
          class: o([e(n).e("classifier")])
        },
        u(e(t)("el.pagination.pageClassifier")),
        3
        /* TEXT, CLASS */
      )
    ], 10, I));
  }
});
export {
  M as default
};
